<div class="grid-holder">
  <kendo-grid class="rowGrid"
              [data]="groups"
              [loading]="loadingService.loaderActive===true"
              [selectable]="{ checkboxOnly: false, mode: 'multiple' }"
              [kendoGridSelectBy]="'groupId'"
              (selectedKeysChange)="keyChangeAddGroup($event)"
              [selectedKeys]="selectedGroups">
    <kendo-grid-column field="groupDesc"  title="" filterable="true"  ></kendo-grid-column>
  </kendo-grid>
  <div class="grid-commands">
    <app-mcl-button class="buttonFixedWidth" text="Add Group" primary="true" (click)="addGroup()"></app-mcl-button>
    <app-mcl-button class="buttonFixedWidth" text="Add All Groups" primary="true" (click)="addAllGroups()"></app-mcl-button>

  </div>

  <kendo-grid [data]="_childChainList"
              [kendoGridSelectBy]="'storeID'"
              [loading]="loadingService.loaderActive==true"
   (selectedKeysChange)="keyChangeAdd($event)"
  [selectedKeys]="selectedChains"
  [selectable]="{ checkboxOnly: false, mode: 'multiple' }"
  class="rowGrid">
  <kendo-grid-column [field]="'field'" title="Stores" filterable="true"  [width]="100"></kendo-grid-column>
  </kendo-grid>
  <div class="grid-commands">
    <app-mcl-button class="buttonFixedWidth" text="Add" primary="true" (click)="addStore()"></app-mcl-button>
    <app-mcl-button class="buttonFixedWidth" text="Add All" primary="true" (click)="addAllStores()" ></app-mcl-button>
    <app-mcl-button class="buttonFixedWidth" text="Remove" primary="true" (click)="removeStore()"></app-mcl-button>
    <app-mcl-button class="buttonFixedWidth" text="Remove All" primary="true" (click)="removeAllStores()"></app-mcl-button>

  </div>
  <kendo-grid class="rowGrid"
              [data]="selectedChainsGrid"
              [selectable]="{ checkboxOnly: false, mode: 'multiple' }"
              [kendoGridSelectBy]="'storeID'"
              [selectedKeys]="selectedChainsSelectedItems"
              (selectedKeysChange)="keyChangeRemove($event)">
    <kendo-grid-column [field]="'field'"  title="Selected Stores"
     filterable="true" [width]="100"></kendo-grid-column>
  </kendo-grid>
</div>
